module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-13.e816b168.png";